import React from "react";

import { useStopPropertyBilling } from "manager/hooks/api";
import { Property } from "manager/interfaces/api";
import { NOTIFICATIONS } from "shared/config/constants";
import useModal from "shared/hooks/useModal";
import { openNotification } from "shared/utils/ui";

import { expectedBillingSnapshot } from "./billingDisplay";
import StopBillingModal from "./StopBillingModal";

interface StopBillingModalContainerProps {
  property: Property;
  onSuccess?: () => void;
}

const StopBillingModalContainer = ({
  property,
  onSuccess,
}: StopBillingModalContainerProps) => {
  const { closeActiveModalDialog } = useModal();
  const { stopPropertyBilling, isSaving } = useStopPropertyBilling();

  const submit = async ({ billingStoppedAt, reason }) => {
    await stopPropertyBilling({
      propertyId: property.id,
      payload: {
        billingStoppedAt,
        reason,
        ...expectedBillingSnapshot(property),
      },
    });
    openNotification(
      `Stopped billing for ${property.name}.`,
      NOTIFICATIONS.info
    );
    closeActiveModalDialog();
    onSuccess?.();
  };

  return (
    <StopBillingModal
      property={property}
      submit={submit}
      submitting={isSaving}
    />
  );
};

export default StopBillingModalContainer;
